import {
  ActionCell,
  CountryCell,
  CurrencyDropDownCell,
  DateCell,
  LinkCell,
  ProgressCell,
  TagCell,
} from '../modules/VehiclesGrid/GridCellRenderers';
import { IColumnMetaData, IPermissions, Vehicle } from '../types';
import { MetaData } from '../types/metaData';
import { Res } from '../types/service';
import { ISavedFilter, ISummaryVehicle } from '../types/vehicle';
import { ENDPOINTS, META_DATA_MODULES, META_DATA_SUB_MODULES } from '../utils/constants';
import request from './HttpService';

type selectedData = {
  previousAssignmentType?: string | '';
  newAssignmentType?: string | '';
  previousBusinessArea?: string | '';
  newBusinessArea?: string | '';
  VIN?: string | '';
  batchNumber?: number | '';
};

type UpdateAssignmentTypesParams = {
  bulk: boolean;
  requestor: string;
  comments: string;
  data: selectedData[];
};

interface Props {
  method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';
  data?: any;
  params?: object;
  url?: string;
}

export const getVehicleSearch = async (searchText: string, page?: number): Promise<Res<Vehicle[]>> => {
  return (
    await request.get(ENDPOINTS.searchVehicles, {
      params: {
        searchText,
        page,
      },
    })
  ).data;
};

export const getMetaData = async (module: string, subModule: string): Promise<MetaData> => {
  const response = await request.get(ENDPOINTS.metaData, {
    params: {
      module,
      subModule,
    },
  });
  return response.data.data[0];
};

export const CellTypes = {
  Link: LinkCell,
  Action: ActionCell,
  Tag: TagCell,
  Date: DateCell,
  CurrencyDropDown: CurrencyDropDownCell,
  Country: CountryCell,
  ProgressBar: ProgressCell,
  Plain: undefined,
};

export const getAssignmenTypes = async () => {
  return (await request.get(ENDPOINTS.getAssignmenTypes)).data.data || [];
};
export const getAllTypes = async () => {
  const AllTypes = await getAssignmenTypes();
  return AllTypes;
};
export const updateAssignmentType = async (data: UpdateAssignmentTypesParams) => {
  // return (await request.put(ENDPOINTS.updateAssignmentType, { params })).data.data;
  const response = await request.put(ENDPOINTS.updateAssignmentType, data);
  return response.data;
};

export const getAllVehicles = async (
  perPage: number,
  page: number,
  sortStatus?: boolean,
  sort?: any,
  search?: any,
  grouping?: any,
  groupKeys?: any,
  filterKeys?: any,
  filterOpKeys?: any
) => {
  try {
    if (filterKeys?.length > 0) {
      filterKeys = filterKeys.join('|');
      if (filterOpKeys?.length > 0) {
        filterOpKeys = filterOpKeys.join('|');
      }
    }

    return (
      (
        await request.post(
          ENDPOINTS.getAllVehicles(
            perPage,
            page,
            sortStatus,
            sort,
            // filter,
            grouping,
            groupKeys
            // filterKeys,
            // filterOpKeys,
          ),
          {
            searchText: search.toString(),
            filter: filterKeys
              .toString()
              .replace(/inventoryVehicle./gi, 'inventoryVehicle_')
              .replace(/customerVehicle./gi, 'customerVehicle_')
              .replace(/prevAssgnChange./gi, 'prevAssgnChange_'),
            filterOp: filterOpKeys.toString(),
          }
        )
      ).data || []
    );
  } catch (err) {
    console.log(err);
    return { data: [] };
  }
};
export const getAllRowData = async (
  perPage: number,
  page: number,
  sortStatus?: boolean,
  sort?: any,
  filter?: any,
  grouping?: any,
  groupKeys?: any,
  filterKeys?: any,
  filterOpKeys?: any
) => {
  // console.log(filter);
  const allVehicles = await getAllVehicles(
    perPage,
    page,
    sortStatus,
    sort,
    filter,
    grouping,
    groupKeys,
    filterKeys,
    filterOpKeys
  );
  return allVehicles;
};
// export const getAllVehicles = async () => {
//   return (await request.get(ENDPOINTS.getAllVehicles)).data || [];
// };
// export const getAllRowData = async () => {
//   const allVehicles = await getAllVehicles();
//   return allVehicles;
// };

export const getVehicleFilterValues = async (fieldName: string) => {
  fieldName = fieldName.replace('.', '_');
  try {
    return (await request.post(ENDPOINTS.getVehicleFilterValues(fieldName))).data || [];
  } catch (err) {
    return { data: [] };
  }
};

export const getChangeHistoryFilterValues = async (fieldName: string) => {
  fieldName = fieldName.replace('.', '_');
  try {
    return (await request.post(ENDPOINTS.getChangeHistoryFilterValues(fieldName))).data || [];
  } catch (err) {
    return { data: [] };
  }
};

export const getAllChangeHistory = async (
  perPage: number,
  page: number,
  sortStatus?: boolean,
  sort?: any,
  search?: any,
  grouping?: any,
  groupKeys?: any,
  filterKeys?: any,
  filterOpKeys?: any
) => {
  try {
    if (filterKeys?.length > 0) {
      filterKeys = filterKeys.join('|');
      if (filterOpKeys?.length > 0) {
        filterOpKeys = filterOpKeys.join('|');
      }
    }
    return (
      (
        await request.post(ENDPOINTS.getAllChangeHistory(perPage, page, sortStatus, sort, grouping, groupKeys), {
          searchText: search.toString(),
          filter: filterKeys
            .toString()
            .replace(/inventoryVehicle./gi, 'inventoryVehicle_')
            .replace(/customerVehicle./gi, 'customerVehicle_')
            .replace(/vehiclDetails./gi, 'vehiclDetails_'),
          filterOp: filterOpKeys.toString(),
        })
      ).data || []
    );
  } catch (err) {
    return { data: [] };
  }
};

export const getColDefs = async () => {
  const response = await getMetaData(META_DATA_MODULES.vehicles, META_DATA_SUB_MODULES.vehiclesGrid);
  const colMetaDataList: IColumnMetaData[] = response?.columnDetails;

  return colMetaDataList.map((colMetaData) => {
    const colDef: any = { field: colMetaData.property, headerName: colMetaData.propertyName };
    colDef.width = colMetaData.width;
    colDef.filter = colMetaData.filterType;
    colDef.type = colMetaData.type;
    return colDef;
  });
};

export const getVehicles = async () => {
  return (await request.get(ENDPOINTS.vehicles)).data.data || [];
};

export const getRowData = async () => {
  const vehicles = await getVehicles();
  return vehicles;
};

export const getVehicleSummary = async (tabName: string, filters: { [key: string]: string[] }) => {
  return ((
    await request.get(ENDPOINTS.vehiclesSummary, {
      params: {
        tabName,
        ...filters,
      },
    })
  ).data.data || []) as ISummaryVehicle[];
};

export const getVehicle = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.getVehicle(reservationId));
  return response.data.data;
};

export const getVehicleConfiguration = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.vehicleConfiguration(reservationId));
  return response.data.data;
};

export const getDeliveryProgress = async (stage: string, subStage?: string) => {
  const response = await request.get(ENDPOINTS.deliveryProgress, {
    params: { stage, subStage },
  });
  return response.data.data;
};

export const getCustomer = async (email: string, reservationId: string) => {
  const response = await request.get(ENDPOINTS.vehicleCustomer(email, reservationId));
  return response.data.data;
};

export const getPayment = async (reservationId: string) => {
  const response = await request.post(ENDPOINTS.vehiclePayment, { reservationId });
  return response.data.data[0];
};

export const getPaymentHistory = async (reservationId: string, lucidId: string) => {
  const response = await request.get(ENDPOINTS.vehiclePayment, { params: { reservationId, lucidId } });
  return response.data.data;
};

export const saveFilter = async (filter: ISavedFilter) => {
  const response = await request.post(ENDPOINTS.vehicleFilters, filter);
  return response.data.data;
};

export const getSavedFilters = async () => {
  const response = await request.get(ENDPOINTS.vehicleFilters);
  return response.data.data as ISavedFilter[];
};

export const deleteFilter = async (filterId: string) => {
  await request.delete(ENDPOINTS.vehicleFiltersDelete(filterId));
};

export const updateFilter = async (filterId: string, filter: Partial<ISavedFilter>) => {
  return (await request.patch(ENDPOINTS.vehicleFiltersDelete(filterId), filter)).data.data as ISavedFilter;
};

export const notifications = (props: Props) => {
  const url = `v1/notifications/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const vehicleService = (props: Props) => {
  const url = `${ENDPOINTS.vehicles}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const lifeCycleSnapshot = (props: Props) => {
  const url = `${ENDPOINTS.lifeCycleSnapshot}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const containmentService = (props: Props) => {
  const url = `${ENDPOINTS.containment}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const simulator = (props: Props) => {
  const url = `${ENDPOINTS.simulator}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const caseService = (props: Props) => {
  const url = `${ENDPOINTS.case}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const populatePayload = (props: Props) => {
  const url = `${ENDPOINTS.productionsStageInfo}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const profile = (props: Props) => {
  const url = `${ENDPOINTS.profile}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const getUserPermissions = async (params: Record<string, string>) => {
  const res = await request.get<Res<IPermissions>>(ENDPOINTS.getPermissions, {
    params,
  });

  return res.data.data;
};

export const inspectionService = (props: Props) => {
  const url = `${ENDPOINTS.inspect}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const paymentService = (props: Props) => {
  const url = `https://payment-service.acrux.staging.ecommerce.pdx.atieva.com/api/v1/payments/transations?referenceId=${
    props?.url ?? ''
  }`;
  return request({
    ...props,
    url,
  });
};

export const payment = (props: Props) => {
  const url = `${ENDPOINTS.vehiclePayment}/${props?.url ?? ''}`;
  return request({ ...props, url });
};

export const getVehicleTeam = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.vehicleTeam(reservationId));
  return response.data.data;
};

export const getTransit = async (VIN: string) => {
  const response = await request.post(ENDPOINTS.transit, { VIN, langCode: 'en-us' });
  return response.data.data;
};

export const getProductionDetails = async (VIN: string) => {
  const response = await request.post(ENDPOINTS.production, { VIN, langCode: 'en-us' });
  return response.data.data;
};

export const billingService = (props: Props) => {
  const url = `${process.env.REACT_APP_BILLING_SERVICE}/${props?.url ?? ''}`;
  return request({
    ...props,
    url,
  });
};

export const getVehicleUpgradeOptions = async (batchNumber: string) => {
  const response = await request.get(ENDPOINTS.vehicleUpgradeOptions(batchNumber));
  return response.data;
};

export const getAssignmentTypesCustomFieldDetails = async (params: any) => {
  const response = await request.post(ENDPOINTS.getAssignmenTypesFieldDetails, params);
  return response.data;
};
